import { render, staticRenderFns } from "./SurchargeFields.vue?vue&type=template&id=07a8f0af&scoped=true"
import script from "./SurchargeFields.vue?vue&type=script&lang=js"
export * from "./SurchargeFields.vue?vue&type=script&lang=js"
import style0 from "./SurchargeFields.vue?vue&type=style&index=0&id=07a8f0af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a8f0af",
  null
  
)

export default component.exports